import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function cyrillicCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const cyrillicPattern = /^[\u0400-\u04FF\s]+$/; // Cyrillic character range and space
        const isValid = cyrillicPattern.test(control.value);
        return isValid ? null : { cyrillicCharacters: true };
    };
}


export function numericValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const numericPattern = /^[0-9]*$/;
        const isValid = numericPattern.test(control.value);
        return isValid ? null : { numeric: true };
    };
}
